import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const FileUpload = ({ onFileSelect, accept = "image/*", label }) => {
    const handleChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            onFileSelect(file);
        }
    };

    return (
        <Box>
            <input
                accept={accept}
                style={{ display: 'none' }}
                id="raised-button-file"
                type="file"
                onChange={handleChange}
            />
            <label htmlFor="raised-button-file">
                <Button
                    variant="outlined"
                    component="span"
                    startIcon={<CloudUploadIcon />}
                >
                    {label}
                </Button>
            </label>
        </Box>
    );
};

export default FileUpload; 